import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-body-large',
  imports: [NgClass],
  templateUrl: './body-large.html',
  styleUrl: './body-large.css'
})
export class BodyLarge {
  @Input() description!: string;
  @Input() class!: string;
}
